export class Level1Data {
  public static LTA_out: string = "";
  public static LTAP_out: string = "";
  public static Gouge_out: string = "";
  public static Sort_order: string = "";
  public static RSFlist: string = "";
  public static Thickness: string[];
  public static Position: string[];
}
